import "./style.css";

export const HowItWorks = () => {
  const steps = [
    { 
      icon: "🚀", 
      title: "Visit Our Platform", 
      description: "Explore our comprehensive range of legal and compliance services tailored to your business needs."
    },
    { 
      icon: "📝", 
      title: "Fill Contact Form", 
      description: "Share your requirements with us through our simple form and select the service you're looking for."
    },
    { 
      icon: "🤝", 
      title: "Connect With Experts", 
      description: "Our experienced CAs and experts will reach out to understand your needs and provide guidance."
    },
    { 
      icon: "✅", 
      title: "Get Solution Done", 
      description: "Sit back and relax while we handle everything—from documentation to final delivery."
    }
  ];

  return (
    <section className="how-it-works">
      <div className="how-it-works-container">
        <h2 className="section-title-center">
          How It Works <span className="subtitle-inline">Simple Steps to Success</span>
        </h2>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-item">
              <div className="step-content">
                <div className="step-circle">
                  <span className="step-icon">{step.icon}</span>
                  <span className="step-number">{index + 1}</span>
                </div>
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="step-connector">
                  <div className="connector-arrow">→</div>
                </div>
              )}
            </div>
          ))}
        </div>
      
      </div>
    </section>
  );
};


